import { ReactElement } from 'react';
import { styled } from 'styled-components';
import layoutStyle from './styles/Layout';

interface Props {
  sidebar: ReactElement;
  mainContent: ReactElement;
}

const PageContainer = styled.div`
  ${layoutStyle}
  background: #fafafa;
  display: grid;
  justify-items: start;
`;

const LayoutGrid = styled.div`
  ${layoutStyle}
  max-width: 1920px;
  display: grid;
  grid-template-columns: 256px 1fr;
`;

const PageLayout = ({ sidebar, mainContent }: Props): ReactElement => {
  return (
    <PageContainer>
      <LayoutGrid>
        {sidebar}
        {mainContent}
      </LayoutGrid>
    </PageContainer>
  );
};

export default PageLayout;
